import { lazy } from "react";
import { getRoute } from "util/react";

export const PageRoute = getRoute(
  { fullPath: "/:locale?/:slug" },
  ":slug",
  lazy(() => import("./index")),
  null,
);

const StaticPageRoute = PageRoute;

export default StaticPageRoute;
